module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/afore33-7fa771b44305042719415fda9e07fff3.jpg";